import { TEMPLATES } from "./constants";

const getParentTopicData = (
  uri = "",
  allPagesData = {}
) => {
  let parentUri = allPagesData[uri]?.parentUri;
  if (parentUri === uri || uri === "" || !parentUri) {
    return { activeChildUri: "", childPages: [] };
  }

  if (
    allPagesData[parentUri]?.templateName ===
    TEMPLATES.TOPIC
  ) {
    const { "child-pages": childPages = [] } =
      allPagesData[parentUri] || {};

    return {
      activeChildUri: uri,
      childPages: childPages,
    };
  }
  return getParentTopicData(parentUri, allPagesData);
};
export const getCTAType = ctaDetails => {
  return ctaDetails?.[0]?.ctaType;
};
export const lastItem = arr => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr[arr.length - 1];
  }
  return undefined;
};
export function uuid() {
  return window?.crypto?.randomUUID?.() || uuidFallback();
}
function uuidFallback() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0;
      // eslint-disable-next-line
      const v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}
export default getParentTopicData;
